import React, { useRef,useState,useEffect }  from 'react'
import {toText,filter_fn} from '../utils.js'
import './uniTable.css'
import icon from '../icons.svg' 
import Edit from './Edit.js'
import TreeView from './TreeView.js'

const rowHeight = 33       // Высота одной строки (в пикселях)
let visibleCount = 20    // Кол-во строк на экране
const maxCount = 300    // Кол-во строк без фільтра
let delta=0           //Ширина прокрутки

function UniTreeTable({haveHeader,colsArr,data,folders,currCol,currFld,ierarc,sorting,filter,filtArr,showFilter,Caption,clickSort,clickHandle,openHandle,fldHandle,saveHandle,cancelHandle,keyHandle,hDragDrop,setFilter=()=>{},tblPos=(d)=>{return 0},needFocus=()=>{return -1},isActive=true}){
    //cols масив обєктів {caption,minWidth,dataId}
    //sorting обєкт {dataId,sort:no/asc/desc}
    const targetRef = useRef()
    const headRef = useRef()
    const filtRef = useRef()
    const bodyRef = useRef()
    //const [scrollTop, setScrollTop] = useState(data.length>maxCount?tblPos():0)
    const [scrollTop, setScrollTop] = useState(tblPos())
    const [isPrinting, setIsPrinting] = useState(false)

    let header=''
    let cols=[]
    let colslen=0
    let savefn=saveHandle
    let cancelfn=cancelHandle
    if (savefn===undefined) savefn=()=>{} 
    if (cancelfn===undefined) cancelfn=()=>{} 
    if (keyHandle===undefined) keyHandle=()=>{} 
    if (hDragDrop===undefined) hDragDrop=()=>{} 
    if (currFld===undefined) currFld={id:null,name:Caption,parent:{}} 
    if (folders===undefined) folders=[] 

    const need_focus=needFocus(0)
    let need_scroll=false

    cols=colsArr
    cols=cols.filter(el=>!el.hiden)
    colslen=cols.length
    if (haveHeader) {
        const hItems=cols.map((col)=>{
            let cls=''
            if (sorting.dataId===col.dataId) cls=sorting.sort
            if (col.typeVal==='submit') savefn=col.setFn
            let stl={minWidth:col.minWidth+'px',width:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
            if(col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',paddingLeft:'0'};cls+=' no-print'}
            else if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px',width:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
            if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
            if(showFilter) stl.borderBottom='none'
            if (col.sortable){
                return(
                    <th className={cls} key={col.dataId} style={stl} onClick={()=>{sortClickHandler(col.dataId)}} title={col.caption==='icon'||col.caption==='ico'?'':col.caption}>
                    {col.caption==='icon'||col.caption==='ico'?'':col.caption}
                    </th>
                )
            } else {
                return(
                    <th className={cls} key={col.dataId} style={stl} title={col.caption==='icon'||col.caption==='ico'?'':col.caption}>
                    {col.caption==='icon'||col.caption==='ico'?'':col.caption}
                    </th>
                )
            }
            })
            let filters=null
            if(showFilter){
                const currFilter=filter||[]
                const colFilter=filtArr||[]
                const f_items=cols.map((col,ind)=>{
                    let cls=''
                    let stl={minWidth:col.minWidth+'px',width:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',overflow:'visible',fontWeight:'normal',position:'relative',borderTop:'none',paddingTop:'0'}
                    if(col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',paddingLeft:'0',borderTop:'none'};cls+=' no-print'}
                    if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
                    const item=currFilter.find(el=>el.dataId===col.dataId)
                    const item2=colFilter.find(el=>el.dataId===col.dataId)
                    if(item){
                        if(item.compare==='lk'){
                            //let typeVal=item.typeVal
                            //if(item.compare==='in_f'||item.compare==='nin_f') typeVal='fld'+typeVal.substring(3)
                            return (<th className={cls} key={col.dataId} style={stl}>
                                <input type='text' value={toText(item.value)} onChange={(e)=>setFilter(col.dataId,e.target.value,item.typeVal)} style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                                <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'4px',top:'6px',width:'14px',height:'14px',opacity:0.5}}/>
                                </th>)
                        } else {
                            return (<th className={cls} key={col.dataId} style={stl}>
                                <input type='text' value={toText(item.value)} disabled={true} style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                                <img src={icon+'#b955'} alt='' style={{position:'absolute',right:'4px',top:'6px',width:'14px',height:'14px',opacity:0.5}}/>
                                </th>)
                        }
                    }else if(item2){
                        return (<th className={cls} key={col.dataId} style={stl}>
                            <input type='text' value={''} onChange={(e)=>setFilter(col.dataId,e.target.value,item2.typeVal)} style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                            <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'4px',top:'6px',width:'14px',height:'14px',opacity:0.5}}/>
                            </th>)
                } else return (<th className={cls} key={col.dataId} style={stl}></th>)
    
                })
                filters=<tr ref={filtRef} style={{overflow:'visible'}}>{f_items}</tr>
            }
        header=
        <table className='valueTable' style={{height:'auto',marginBottom:'-1px'}}><thead><tr ref={headRef}>
            {hItems}
        </tr>{filters}</thead></table>
    }
    let dat=[]
    if(currFld.id) {
        let curFld=folders.find(e=>e.id===currFld.id)
        if(curFld) currFld=curFld
    }
    if(ierarc){
        if(currFld.id) dat=[{...currFld,isfolder:true,top:true}]
        let fld=folders.filter(el=>el.parent&&el.parent.id===currFld.id)
        dat=dat.concat(fld.map(el=>{return({...el,isfolder:true})}))
        let its=data.filter(el=>el.parent.id===currFld.id)
        dat=dat.concat(its)
    }
    else{
        //dat=folders.map(el=>{return({...el,isfolder:true})}).concat(data)
        dat=[...data]
    }
    if (filter!=='' && filter!==undefined){
        dat=dat.filter((item,idx)=>{return filter_fn(item,filter)})
    }

    let cur_idx=0
    if(currCol) cur_idx=dat.findIndex(item=>(currCol.uid && currCol.uid===item.uid) || (!currCol.uid && item.id && currCol.id===item.id))
    let dat2=[]
    // Вычисляем индекс строки, с которой начинаем отображение
    let startIndex = Math.floor(scrollTop / rowHeight);
    if(cur_idx<startIndex&&need_focus!==-1){
        startIndex=Math.max(cur_idx - 2, 0)
        need_scroll=true
    }
    if(!currCol&&need_focus===1){
        startIndex=0
        need_scroll=true
        needFocus()
    }
    // Определяем индекс последней строки, которую нужно отобразить
    const totalRows=dat.length  
    let endIndex = Math.min(startIndex + visibleCount + 1, totalRows)
    if(data.length>maxCount&&!isPrinting) dat2=dat.filter((item,idx)=>idx>=startIndex&&idx<endIndex) 
    else {dat2=dat}
    //якщо треба позиціонувати, перевіряємо чи попадає рядок в діапазон і міняємо
    if(cur_idx>endIndex&&need_focus!==-1){
        let endIndex = Math.min(cur_idx + 3, totalRows)
        startIndex=Math.max(endIndex-visibleCount, 0)
        need_scroll=true
    }
    if(need_scroll){
        tblPos(startIndex*rowHeight)
        if(bodyRef.current) bodyRef.current.scrollTop=startIndex*rowHeight
    }

    function setFocus(el){
        if (!el) return
        const need_focus=needFocus()
        if(need_focus===-1) return
        if(need_focus===-2){
            if (document.activeElement.nodeName==='INPUT') return
            el.focus()
            return
        }
        if(need_focus===0) {
            el.focus()
            return
        }
    }

    function tblBlur(e){
        const el=e.relatedTarget
        if(!el) return
        if(!bodyRef.current) return
        if(bodyRef.current.contains(el)) return
        const utt=document.getElementById('utt')
        if(utt&&utt.contains(el)) {needFocus(1);return}
        needFocus(-1)
    }

    const keyClick=(e)=>{
        // Глобальний блок клавіш
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
        }
        let pref=''
        if(e.shiftKey) pref+='shift_'
        if(e.ctrlKey) pref+='ctrl_'
        if(e.altKey) pref+='alt_'
        if(e.key==='ArrowUp') {lastItem()}
        else if(e.key==='ArrowDown') {nextItem()}
        else if(e.key==='PageDown') {next10Item()}
        else if(e.key==='PageUp') {last10Item()}
        else if(e.key==='Home') {firstItem()}
        else if(e.key==='End') {endItem()}
        else keyHandle(pref+e.key)
    }

    const allovDrop=(e)=>{
        e.preventDefault();
    }

    const dragEnter=(e)=>{
        if(e.target.tagName==='TD') e.target.parentNode.style.background='#92929233'
    }

    const dragLeave=(e)=>{
        if(e.target.tagName==='TD') e.target.parentNode.style.background=''
    }

    const dragDrop=(e,targ)=>{
        const item=e.dataTransfer.getData('item')
        if(!item) return
        if(e.target.tagName==='TD') e.target.parentNode.style.background=''
        //let trg={...targ.parent}
        let trg={...targ}
        let itm=JSON.parse(item)
        if(itm.parent.id===trg.id) trg={...targ.parent}
        if(!trg.name) trg.name=Caption
        delete trg.isGroup
        delete trg.data
        hDragDrop(itm,trg)
    }

    let items=dat2.map((item,idx)=>{
        const clickFn=()=>{clickHandle(item)}
        const enterFn=(e)=>{if(e.key === 'Enter') {e.stopPropagation();setTimeout(openHandle,150)}}
        if (typeof currCol!=='undefined' && currCol.id===item.id && currCol.isfolder===item.isfolder){
            if (currCol.edit){
                return (
                    <tr ref={el=>{setFocus(el);return targetRef}} className='selected' tabIndex='0' key={idx} title={item.title||''} onClick={clickFn} onDoubleClick={openHandle} onKeyUp={e=>{if(e.key === 'Enter') savefn()}}>
                {cols.map((col,ind)=>{
                    let cls=null
                    let stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
                    if(col.typeVal==='submit'||col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',textAlign:'center',paddingLeft:'0'};cls='no-print'}
                    else if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
                    if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
                    let td=typeof col.typeVal==='undefined'?toText(item[col.dataId]):<Edit Value={item[col.dataEdit===undefined?col.dataId:col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} />
                    if (ind+1===colslen) td=<div style={{display:'flex'}}><div style={{width:'calc(100% - 44px)'}}><Edit Value={item[col.dataEdit===undefined?col.dataId:col.dataEdit]} typeVal={col.typeVal} setVal={col.setFn} /></div><div onClick={()=>{savefn()}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#okBut'} alt={''} /></div><div onClick={()=>{cancelfn()}} tabIndex='0' className='smallButton'><img className='ico' src={icon+'#canBut'} alt={''} /></div></div>
                    else if (col.caption==='icon') td=<img className='ico' src={icon+'#'+(item.isfolder?(item.id===currFld.id?'catFolderO':'catFolderC'):col.dataId)+(item.marked==='1'?'Del':'')} alt={''} />
                    return (
                    <td key={col.dataId} style={stl} className={cls}>
                    {td}
                    </td>)})}
    
                </tr>
                )
    
            }
            else{
                return (
                    <tr draggable='true' 
                        ref={el=>{setFocus(el);return targetRef}} 
                        className='selected' tabIndex='0' key={idx}  title={item.title||''}
                        onDragStart={(e)=>{e.dataTransfer.setData('item', JSON.stringify(item))}}
                        onClick={clickFn} onDoubleClick={openHandle} onKeyUp={enterFn}>
                {cols.map((col)=>{
                    let cls=null
                    let stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
                    if(col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',textAlign:'center',paddingLeft:'0'};cls='no-print'}
                    else if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
                    if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
                    if(col.typeCol==='check'&&!item.isfolder) return(<td key={col.dataId} style={stl} className={cls}><input type='checkbox' checked={parseInt(item[col.dataId]||0)} readOnly={true} /></td>)
                    const td_cont=toText(item[col.dataId])
                    return (
                    <td key={col.dataId} style={stl} className={cls} title={(td_cont?.length>20?td_cont+"\n":'')+(item.title||'')}>
                    {col.caption==='icon'?<img className='ico' src={icon+'#'+(item.isfolder?(item.id===currFld.id?'catFolderO':'catFolderC'):col.dataId)+(item.marked==='1'?'Del':'')} alt={''} />:td_cont}
                    </td>)})}
    
                </tr>
                )
    
            }
        }
        else if(item.isfolder) {
            return (
            <tr tabIndex='0' key={idx} title={item.title||''} onClick={clickFn} onDoubleClick={openHandle} onKeyUp={enterFn}
            onDragOver={allovDrop} onDragEnter={dragEnter} onDragLeave={dragLeave} onDrop={(e)=>dragDrop(e,item)}>
            {cols.map((col)=>{
                let cls=null
                let stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
                if(col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',textAlign:'center',paddingLeft:'0'};cls='no-print'}
                else if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
                if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
                const td_cont=toText(item[col.dataId])
                return (
                <td key={col.dataId} style={stl} className={cls} title={(td_cont?.length>20?td_cont+"\n":'')+(item.title||'')}>
                {col.caption==='icon'?<img className='ico' src={icon+'#'+(item.id===currFld.id?'catFolderO':'catFolderC')+(item.marked==='1'?'Del':'')} alt={''} />:td_cont}
                </td>)})}

            </tr>
            )
        }
        else {
            return (
            <tr tabIndex='0' key={idx} title={item.title||''} onClick={clickFn} onDoubleClick={openHandle} onKeyUp={enterFn}>
            {cols.map((col)=>{
                let cls=null
                let stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
                if(col.caption==='icon'||col.caption==='ico') {stl={width:col.minWidth+'px',minWidth:col.minWidth-4+'px',textAlign:'center',paddingLeft:'0'};cls='no-print'}
                else if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
                if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
                if(col.typeCol==='check') return(<td key={col.dataId} style={stl} className={cls}><input type='checkbox' checked={parseInt(item[col.dataId]||0)} readOnly={true} /></td>)
                const td_cont=toText(item[col.dataId])
                return (
                <td key={col.dataId} style={stl} className={cls} title={(td_cont?.length>20?td_cont+"\n":'')+(item.title||'')}>
                {col.caption==='icon'?<img className='ico' src={icon+'#'+col.dataId+(item.marked==='1'?'Del':'')} alt={''} />:td_cont}
                </td>)})}

            </tr>
            )
        }
    })

    const sortClickHandler=(dataId)=>{
        let sort=sorting.sort
        if (sorting.dataId===dataId) {
            if (sort==='no') sort='asc'
            else if (sort==='asc') sort='desc'
            else sort='asc'
            clickSort(dataId,sort)
        }
        else {
            sort='asc'
            clickSort(dataId,sort,data)
        }
    }

    let lastItem=()=>{}
    let nextItem=()=>{}
    let last10Item=()=>{}
    let next10Item=()=>{}
    let firstItem=()=>{}
    let endItem=()=>{}
    if (currCol!==undefined){
        const idx=dat.findIndex(el=>(!currCol.uid && currCol.id===el.id) || (currCol.uid && currCol.uid===el.uid))
        if (idx!==-1){
            if(idx>0) lastItem=()=>{clickHandle({...dat[idx-1]})}
            if(dat.length-1>idx) nextItem=()=>{clickHandle({...dat[idx+1]})}
            if(idx>49) last10Item=()=>{clickHandle({...dat[idx-50]})}
            else last10Item=()=>{clickHandle({...dat[0]})}
            if(dat.length-50>idx) next10Item=()=>{clickHandle({...dat[idx+50]})}
            else next10Item=()=>{clickHandle({...dat[dat.length-1]})}
        }
        firstItem=()=>{clickHandle({...dat[0]})}
        endItem=()=>{clickHandle({...dat[dat.length-1]})}
    } else if(dat.length>0) {
        lastItem=()=>{clickHandle({...dat[0]})}
        nextItem=()=>{clickHandle({...dat[0]})}
        last10Item=()=>{clickHandle({...dat[0]})}
        next10Item=()=>{clickHandle({...dat[0]})}
        firstItem=()=>{clickHandle({...dat[0]})}
        endItem=()=>{clickHandle({...dat[dat.length-1]})}
    }

    const scrl2=(e)=>{
        tblPos(e.target.scrollTop)
        /*if(data.length>maxCount)*/ setScrollTop(e.target.scrollTop)
    }

    useEffect(() => {
        if(bodyRef.current){
            /*if(data.length>maxCount)*/ bodyRef.current.scrollTop=tblPos()
            /*if(data.length>maxCount)*/ visibleCount=bodyRef.current.offsetHeight/rowHeight
            if(bodyRef.current.scrollHeight>bodyRef.current.clientHeight){
                if(headRef.current){
                    delta=bodyRef.current.offsetWidth-bodyRef.current.lastChild.offsetWidth
                    let new_width=parseInt(cols[cols.length-1].minWidth)+delta
                    if (new_width<0) new_width=1
                    headRef.current.lastChild.style.flexBasis=new_width+'px'
                    if(cols[cols.length-1].maxWidth) headRef.current.lastChild.style.maxWidth=(parseInt(cols[cols.length-1].maxWidth)+delta)+'px'
                    if(filtRef.current) {
                        filtRef.current.lastChild.style.flexBasis=new_width+'px'
                        if(cols[cols.length-1].maxWidth) filtRef.current.lastChild.style.maxWidth=(parseInt(cols[cols.length-1].maxWidth)+delta)+'px'
                    }
                }
            }
        }
    // eslint-disable-next-line 
    },[data])

    useEffect(() => {
        // Проверяем поддержку matchMedia
        if (!window.matchMedia) return
        const mediaQuery = window.matchMedia('print');
        // Функция-обработчик
        const handleChange = (e) => {
            setIsPrinting(e.matches)     // e.matches будет true, когда браузер переходит в режим печати (или предпросмотра)
        }
        // Устанавливаем начальное значение
        setIsPrinting(mediaQuery.matches)
        // Подписываемся на изменения
        mediaQuery.addEventListener('change',handleChange)
        // Очистка подписки при демонтировании компонента
        return () => {mediaQuery.removeEventListener('change',handleChange)}
    }, [])

    return(
        <div id='utt' style={{display:'flex',flexDirection:'row',height:'calc(100% - 30px)'}}>
            <div className='no-print' style={{width:'20%',minWidth:'150px'}}><TreeView TreeData={folders} Caption={Caption} currFolder={currFld} hClick={fldHandle} hDragDrop={hDragDrop} isActive={isActive}/></div>
            <div style={{width:'80%',display:'flex',flexDirection:'column'}} onKeyUp={keyClick}>
                    {header}
      <div
        ref={bodyRef}
        onScroll={scrl2}
        style={{
          //height: `${rowHeight * visibleCount}px`,
          height: '100%',
          width: '100%',
          overflowY: 'auto',
          border: 'none',
        }}
      >
        {/* Обгортка для скрола */}
        <div style={{ height: `${rowHeight * totalRows}px`, position: 'relative' }}>
        <table id='ut' className='valueTable' style={{position: 'absolute',top: `${data.length>maxCount&&!isPrinting?startIndex * rowHeight:0}px`,marginTop:0}} onBlur={tblBlur}>
                    
                    <tbody ref={bodyRef}>
                    {items}
                    </tbody>
                </table>
            </div>
            </div>
            </div>
        </div>    
            
    )


}

export default UniTreeTable